
<div
  v-if="produit"
  v-resize:debounce="onResize"
  class="d-flex flex-column cursor-pointer produit-item justify-content-start"
  :class="[
    jel_getClassObject(content),
    { 'produit-desactive': produitDesactivation && produitDesactivation.indDesactive },
    content.nbColonne == 2 ? 'h-100' : 'py-1',
    { 'pt-2': content.elementPremiereLigne },
  ]"
>
  <b-link
    v-if="isVisible"
    v-bind="jel_getLienBinding(mixinProduitCasino_getLienPageProduit())"
    class="produit-casino overflow-hidden"
    :class="content.nbColonne == 2 || content.isListeHorizontale ? 'm-n4px p-4px' : 'p-1'"
  >
    <template v-if="!content.isListeHorizontale">
      <div class="image position-relative overflow-hidden">
        <div class="disabled-overlay"></div>
        <MediaImageLogo :content="contentMediaImageLogo" />
        <div
          v-if="isLotProgressif && (!produitDesactivation || !produitDesactivation.indDesactive)"
          class="lot-progressif position-absolute h-25 w-100 d-flex justify-content-center align-items-center font-weight-bold"
          :style="{ '--couleur': progressif.couleur ? progressif.couleur : '#060606' }"
          v-html="texteBandeProgressif"
        />
      </div>
      <div class="section-texte">
        <div
          class="titre-jeu graphik_bold pt-0-5 titre-jeu-col-2"
          v-html="mixinProduitCasino_getTitre()"
        ></div>
        <div
          class="mise-jeu graphik_regular font-weight-normal pt-0-5"
          v-html="mixinProduitCasino_getMiseMinMax()"
        ></div>
        <div
          v-if="validationProgressif"
          class="graphik_regular font-weight-normal progressif-multiple"
        >
          {{ $i18n.t('messageComponent.progressifsMultiples') }}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="image position-relative overflow-hidden">
        <div class="disabled-overlay"></div>
        <MediaImageLogo :content="contentMediaImageLogo" />
      </div>
      <div class="section-texte text-center typography-carte-liste-mobile">
        <div
          class="titre-jeu graphik_medium pt-0-5 titre-jeu-horizontale"
          v-html="mixinProduitCasino_getTitre()"
        ></div>
        <div v-if="isLotProgressif">
          <div v-if="mntProgressif" class="lot-progressif graphik_bold">
            {{ formatMontantProgressif }}
          </div>
          <div v-else class="progressif-multiple graphik_medium">
            {{ $i18n.tc('messageComponent.progressif', nbProgressif) }}
          </div>
        </div>
      </div>
    </template>
  </b-link>
  <div
    v-else
    v-observe-visibility="{
      callback: visibilityChanged,
      once: true,
    }"
    class="chargement"
  >
    <span>{{ mixinProduitCasino_getTitre(false) }}...</span>
  </div>
</div>
